import { useContext, useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';
import { withStyles, createStyles } from "@material-ui/styles";
import React from 'react';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import Link from 'next/link';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

//import '../../../pages/_app'


const menuButton = "/Images/MenuButton.png";

const useStyles = makeStyles({
    list: {
        width: 300,
    },
    fullList: {
        width: 'auto',
    }
});


function TemporaryDrawer() {
    const classes = useStyles();
    const [state, setState] = React.useState({
        top: false,
        left: false,
        bottom: false,
        right: false,
    });

    const toggleDrawer = (side, open) => event => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }

        setState({ ...state, [side]: open });
    };

    const sideList = side => (
        <div
            className={classes.list}

            role="presentation"
            onClick={toggleDrawer(side, false)}
            onKeyDown={toggleDrawer(side, false)}
        >
            <List>
                <Link href="index">
                    <ListItem button key={"Home"}>

                        <ListItemText primary="Home" /> </ListItem>
                </Link>
                <Divider />
            </List>

            <List>
                <Divider />
                <Link href="business_model">
                    <ListItem button key={"Check your Business Model"}>

                        <ListItemText primary="Check your Business Model" /> </ListItem>
                </Link>
                <Divider />

            </List>

            <List>
                <Divider />
                <Link href="explore_laws">
                    <ListItem button key={"Explore Laws and Regulations"}>

                        <ListItemText primary="Explore Laws and Regulations" /> </ListItem>
                </Link>
                <Divider />
            </List>

            <List>
                <Divider />
                <Link href="investment_hub">
                    <ListItem button key={"The Investment Hub"}>

                        <ListItemText primary="The Investment Hub" /> </ListItem>
                </Link>
                <Divider />
            </List>


            <List>
                <Divider />
                <Link href="about">
                    <ListItem button key={"About"}>

                        <ListItemText primary="About" /> </ListItem>
                </Link>
                <Divider />
            </List>

        </div>
    );

 

    return (

        <div >
            <div className='drawer_menuButtonBox' onClick={toggleDrawer('left', true)}>
                < img src={menuButton} className="drawer_menuButton_CSS" />
            </div>


            <Drawer open={state.left} onClose={toggleDrawer('left', false)}>
                {sideList('left')}
            </Drawer>

        </div>
    );
}

export default TemporaryDrawer;

